import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { IS_APP_CODEAC, STRIPE_PUBLISHABLE_KEY } from "../../../constants/env";
import Layout from '../../../containers/Layout';
import ActiveRepository from './ActiveRepository';
import WebhookLanding from './WebhookLanding';
import DisabledRepository from './DisabledRepository';
import InsufficientPermissionLanding from './InsufficientPermissionLanding';
import TrialModal from '../../SettingsPage/containers/TrialModal';
import Setup from '../../../components/Setup';
import ScrollToTopOnMount from './ScrollToTop';
import { VCS_LINK } from '../../../constants/api';
export const defaultUrl = '/:vcs/:owner/:repository';
function checkTrialEnd(user, repository) {
    const today = new Date();
    let showTrialEndModal = false;
    const expirationDate = user && user.plan && user.plan.trialExpirationDate && new Date(user.plan.trialExpirationDate);
    if (expirationDate) {
        const expirationDatePlus14days = expirationDate.setDate(new Date(expirationDate.getDate() + 14));
        showTrialEndModal = repository?.private && user.plan.price > 0;
        const closedModal = localStorage.getItem('closeTrialEndModal');
        if (closedModal) {
            const closedModalDate = new Date(closedModal);
            // @ts-expect-error TS2345: Argument of type Date is not assignable to parameter of type number
            const closedModalPlus14Days = closedModalDate.setDate(new Date(closedModalDate.getDate() + 14));
            showTrialEndModal = showTrialEndModal && closedModalPlus14Days <= today.getTime();
        }
        else {
            showTrialEndModal = showTrialEndModal && today.getTime() > expirationDatePlus14days;
        }
    }
    return showTrialEndModal;
}
export const RepositoryDetail = ({ repository, user, match, loaded, isEmpty, branch, activeBranch, processingPercentage, loadingBranches, history, loadRepository, showBranch, loadCommitList, registerWebHookAction, }) => {
    const handleBranchClick = async (branchId) => {
        const repositoryBranch = repository.getBranchById(branchId);
        await loadRepository(repositoryBranch.name);
    };
    const isRepositoryPrivate = !!repository?.private;
    const isLoginRequired = repository && 'private' in repository ? isRepositoryPrivate : false;
    const fullname = repository.getFullName();
    let isAdmin = false;
    let showTrialEndModal = false;
    if (user.user) {
        const admins = repository?.admins ?? [];
        isAdmin = admins.includes(user.user.id);
        showTrialEndModal = IS_APP_CODEAC && checkTrialEnd(user.user, repository);
    }
    const vcsLink = VCS_LINK[repository?.vcs] + '/' + fullname;
    const hideTrial = !IS_APP_CODEAC ||
        !repository?.private ||
        !repository?.active ||
        !repository?.branches.length ||
        !user?.user ||
        !user?.user.plan ||
        user?.user?.plan.price ||
        !STRIPE_PUBLISHABLE_KEY ||
        !isAdmin;
    const titleParts = repository.getTitleParts();
    const titleSecondary = titleParts.titleSecondary;
    const titlePrimary = titleParts.titlePrimary;
    let showEmpty = isEmpty;
    let branchName;
    try {
        const mainBranch = repository?.getMainBranch().name;
        branchName = branch && mainBranch !== branch.name ? branch.name : activeBranch?.name;
    }
    catch {
        showEmpty = true;
    }
    return (_jsxs(Layout, { loginRequired: isLoginRequired, withDrawer: true, title: titlePrimary, loading: !loaded, match: match, titlePrimary: titlePrimary, titleSecondary: titleSecondary, repository: repository, children: [IS_APP_CODEAC ? _jsx(ScrollToTopOnMount, {}) : null, loaded && (_jsxs("div", { className: "container repository-detail__container", children: [repository.active && (_jsx(ActiveRepository, { repository: repository, repositoryUrl: defaultUrl, branch: branchName, onBranchClick: handleBranchClick, onChangePage: loadCommitList, onRefreshClick: () => showBranch(branch, true), loadingBranches: loadingBranches, loaded: loaded, trialNewlyActivated: user.trialNewlyActivated, vcsLink: vcsLink, processingPercentage: processingPercentage, match: match, history: history, isEmpty: showEmpty })), !repository.active && isAdmin &&
                        _jsx(_Fragment, { children: repository.disabled ?
                                _jsx(DisabledRepository, { gha: !!user.user?.gha, repositoryName: repository.name })
                                : (_jsx(_Fragment, { children: _jsx(WebhookLanding, { gha: !!user.user?.gha, loading: repository.webhookLoading, repositoryName: repository.name, registerCallback: registerWebHookAction, vcs: repository.vcs }) })) }), !repository.active && !isAdmin && _jsx(InsufficientPermissionLanding, { gha: !!user.user?.gha, repositoryName: repository?.name }), hideTrial ? null : _jsx(TrialModal, {}), showTrialEndModal && _jsx(TrialModal, { isEnded: true })] })), repository?.private && _jsx(Setup, { loading: !loaded })] }));
};
